import {
  Estimate,
  VendorOrder,
} from '../../../../shared/models/vendor-order.model';

export type CancellationOrigin = 'pending' | 'reviewed' | 'expired' | null;

export function isRejectedEstimate(estimate: Estimate): boolean {
  return (
    estimate.jobStatus?.toUpperCase() === 'REJECTED' ||
    !!estimate.rejection ||
    !!estimate.rejectedCode
  );
}

export function isEstimateApproved(estimate: Estimate): boolean {
  const quote = estimate.quote as
    | {
        acceptedBy?: string;
        acceptedDate?: string;
        normal?: { acceptedBy?: string; acceptedDate?: string };
        rushed?: { acceptedBy?: string; acceptedDate?: string };
      }
    | undefined;

  const acceptedBy =
    quote?.acceptedBy?.trim() ??
    quote?.normal?.acceptedBy?.trim() ??
    quote?.rushed?.acceptedBy?.trim();
  const acceptedDate =
    quote?.acceptedDate?.trim() ??
    quote?.normal?.acceptedDate?.trim() ??
    quote?.rushed?.acceptedDate?.trim();

  return !!acceptedBy && !!acceptedDate;
}

export function getCancellationOrigin(
  order: VendorOrder | null | undefined,
): CancellationOrigin {
  if (!order || order.jobStatus !== 'CANCELLED') return null;

  if (isExpiryCancellation(order)) return 'expired';

  const estimates = order.estimates ?? [];
  const hasApproved = estimates.some(
    (e) => !isRejectedEstimate(e) && isEstimateApproved(e),
  );
  const hasRejected = estimates.some((e) => isRejectedEstimate(e));

  if (!hasApproved && !hasRejected) return 'pending';
  return 'reviewed';
}

export function isExpiryCancellation(
  order: VendorOrder | null | undefined,
): boolean {
  if (!order || order.jobStatus !== 'CANCELLED') return false;
  return order.allQuotesExpired === true;
}

export function isCancelledFromPending(
  order: VendorOrder | null | undefined,
): boolean {
  return getCancellationOrigin(order) === 'pending';
}

export function isCancelledFromReviewed(
  order: VendorOrder | null | undefined,
): boolean {
  return getCancellationOrigin(order) === 'reviewed';
}

export function isCancelledFromExpired(
  order: VendorOrder | null | undefined,
): boolean {
  return getCancellationOrigin(order) === 'expired';
}
